import { requestAccessToken as clientRequestAccessToken } from "../generated/index";

// Wrapper around generated requestAccessToken to add the required body parameters
const requestAccessToken = async () => {
  if (!process.env.MDI_CLIENT_ID || !process.env.MDI_CLIENT_SECRET) {
    throw new Error("MDI_CLIENT_ID and MDI_CLIENT_SECRET must be set");
  }

  return clientRequestAccessToken({
    body: {
      client_id: process.env.MDI_CLIENT_ID,
      client_secret: process.env.MDI_CLIENT_SECRET,

      // static values
      grant_type: "client_credentials",
      scope: "*",
    },
  });
};

/* TODO(kv-store) - Access Token Management
 * The following functions would work for local developement, but as we are using
 * vercel serverless functions, we can't store the access token in memory.
 *
 * The proposed solution is the access token should be stored in KV store. With a
 * lock mechanism to prevent requests inflight using a counterfeit token.
 *
 * In this scenario we store two values to the store:
 *  - a read-count mutex indicating when the token is being read, and
 *  - the access token itself.
 *
 * A cron job running every 23 hours will lock the mutex, wait for it to clear, fetch
 * a new access token, store it, and then release the mutex. A “read-modify-write”
 * lock could also be used.
 *
 * The best solution if f*king MDI would allow service accounts where access tokens
 * have no expiry. Then the code as written would be fine.
 */

let accessToken: string | null = null;

export const isValidAccessToken = () => !!accessToken;

export const getAccessToken = async (): Promise<string> => {
  if (!accessToken) {
    const { data, error } = await requestAccessToken();

    // @ts-expect-error
    if (error) throw new Error(error.message);

    accessToken = data?.access_token!;
  }
  return accessToken!;
};
